import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Components/Login';
import LoadingOverlay from './Components/LoadingOverlay';

function ElectronBackButton() {
  const location = useLocation();
  if (!window.electronAPI?.isElectron) return null;
  // Hide on login page — nowhere to go back to
  if (location.pathname === '/' || location.pathname === '/login') return null;
  return (
    <button
      onClick={() => window.electronAPI.goBack()}
      style={{
        position: 'fixed', top: 12, left: 12, zIndex: 10000,
        background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: 8, padding: '6px 12px', color: '#fff',
        cursor: 'pointer', fontSize: 13, fontWeight: 600,
        backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', gap: 6,
      }}
      title="Go back"
    >
      ← Back
    </button>
  );
}

// Lazy-load all route components for code splitting
const Dashboard = React.lazy(() => import('./Components/Dashboard'));
const AllCards = React.lazy(() => import('./Components/AllCards'));
const GamePage = React.lazy(() => import('./Components/GamePage'));
const Report = React.lazy(() => import('./Components/Reports'));
const AdminTable = React.lazy(() => import('./Components/AllStats'));
const BlockedPage = React.lazy(() => import('./Components/Blocked'));
const Henok = React.lazy(() => import('./Components/Henok'));
const CustomCardSetManager = React.lazy(() => import('./Components/CustomCardSetManager'));
const JackpotManager = React.lazy(() => import('./Components/JackpotManager'));
const MobileAdmin = React.lazy(() => import('./Components/MobileAdmin/MobileAdmin'));
const ShopOwnerLogin = React.lazy(() => import('./Components/ShopOwner/ShopOwnerLogin'));
const ShopDashboard = React.lazy(() => import('./Components/ShopOwner/ShopDashboard'));
const MobilePlayer = React.lazy(() => import('./Components/MobilePlayer/MobilePlayer'));
const BingoCards = React.lazy(() => import('./Components/BingoCards/BingoCards'));
const Teddy = React.lazy(() => import('./Components/Teddy'));
const UnoHenok = React.lazy(() => import('./Components/UnoHenok'));
const Mule = React.lazy(() => import('./Components/Mule'));
const DynamicDashboard = React.lazy(() => import('./Components/DynamicDashboard'));
const EventManager = React.lazy(() => import('./Components/EventGame/EventManager'));
const EventPage = React.lazy(() => import('./Components/EventGame/EventPage'));
const EventsLanding = React.lazy(() => import('./Components/EventGame/EventsLanding'));
const OwnerLogin = React.lazy(() => import('./Components/Owner/OwnerLogin'));
const OwnerDashboard = React.lazy(() => import('./Components/Owner/OwnerDashboard'));

function App() {

  return (
    <BrowserRouter>
      <ElectronBackButton />
      <Suspense fallback={<LoadingOverlay />}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/all-cards" element={<AllCards />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/game-in-progress" element={ <GamePage />} />
          <Route path="/reports" element={ <Report />} />
          <Route path="/pyt/axs" element={ <AdminTable />} />
          <Route path="/blocked" element={<BlockedPage />} />
          <Route path="/henok" element={<Henok />} />
          <Route path="/card-sets" element={<CustomCardSetManager />} />
          <Route path="/jackpot" element={<JackpotManager />} />
          <Route path="/mobile-admin" element={<MobileAdmin />} />
          <Route path="/shop-login" element={<ShopOwnerLogin />} />
          <Route path="/shop-dashboard" element={<ShopDashboard />} />
          <Route path="/mobile" element={<MobilePlayer />} />
          <Route path="/bingo-cards" element={<BingoCards />} />
          <Route path="/teddy" element={<Teddy />} />
          <Route path="/uno-henok" element={<UnoHenok />} />
          <Route path="/mule" element={<Mule />} />
          <Route path="/panel" element={<DynamicDashboard />} />
          <Route path="/event-manager" element={<EventManager />} />
          <Route path="/events/:adminUsername" element={<EventsLanding />} />
          <Route path="/events/:adminUsername/:slug" element={<EventPage />} />
          <Route path="/owner/login" element={<OwnerLogin />} />
          <Route path="/owner" element={<OwnerDashboard />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
